<div class="postcode">
  <label [for]="id">{{ label | i18next }}</label>
  <div class="input">
    <div class="loader" *ngIf="isLoading">
      <mat-spinner aria-label="loader"></mat-spinner>
    </div>
    <input
      #postcodeInput
      type="text"
      [id]="id"
      [name]="id"
      placeholder="{{ placeholder ? (placeholder | i18next) : '' }}"
      [ngClass]="{ error: hasError, 'ng-invalid': hasError }"
      [attr.aria-required]="isRequired"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="errorId"
      aria-haspopup="true"
      [attr.aria-expanded]="suggestionsVisible"
      [attr.aria-controls]="controlsId"
      (keydown)="handlePostcodeKeyEvent($event)"
      [(ngModel)]="value"
      (ngModelChange)="handleSearchInput($event)"
      (blur)="handleInputBlur()"
      (focus)="handleInputFocus()"
      [disabled]="isLoading"
    />
    <i
      class="fa fa-exclamation-triangle"
      aria-hidden="true"
      *ngIf="hasError || hasSearchError"
    >
    </i>
  </div>
  <span class="app-error-text" [id]="errorId">
    {{ hasError && !hasSearchError ? (errorText | i18next) : '' }}
  </span>

  <span class="app-error-text" [id]="errorId" *ngIf="hasSearchError">
    {{ 'postcode_lookup_no_results_found' | i18next }}
  </span>

  <div
    [id]="controlsId"
    [hidden]="!suggestionsVisible || hasSearchError"
    class="postcodeResults"
  >
    <ul tabindex="-1" [id]="itemsId" class="postcodeList">
      <li
        role="option"
        *ngFor="
          let address of addressSuggestions;
          let addressIndex = index;
          trackBy: trackByFn
        "
      >
        <button
          type="button"
          #postcodeItem
          class="listButton"
          (keydown)="handleDropdownKeyEvent(address.id, $event)"
          (click)="handleSelectClick(address.id)"
          [id]="getSuggestionId(address.id!)"
          (mouseover)="focusOnSuggestion(addressIndex)"
          (blur)="handleSuggestionsBlur()"
        >
          <p>{{ address.label }}</p>

          <span *ngIf="address.containerSize && address.containerSize > 1">
            {{
              'postcode_result_addresses'
                | i18next: { count: address.containerSize }
            }}
          </span>
          <span *ngIf="address.containerSize === 0">
            {{ 'postcode_result_single_address' | i18next }}
          </span>
        </button>
      </li>
    </ul>
  </div>

  <nx-ng-select
    [id]="itemsId"
    *ngIf="mobileSuggestionsVisible"
    [placeholder]="selectPlaceholderText"
    (select)="handleSelectClick($event)"
    [isPostcodeResults]="true"
    class="postcodeResultsMobile"
  >
    <option *ngFor="let address of addressSuggestions" [value]="address.id">
      {{ formatAddressForSelect(address) }}
    </option>
  </nx-ng-select>
</div>
